var getDefaultAlignment = function getDefaultAlignment(_ref) {
  var currentIndex = _ref.currentIndex,
    minIndex = _ref.minIndex,
    maxIndex = _ref.maxIndex,
    hasSlideOverflow = _ref.hasSlideOverflow;
  if (!hasSlideOverflow) {
    // There aren't enough slides
    return 'center';
  }
  if (currentIndex === maxIndex) {
    return 'right';
  }
  if (currentIndex === minIndex) {
    return 'left';
  }
  return 'center';
};
export default getDefaultAlignment;